/**
 * Scroll Animations Module
 * Implements IntersectionObserver-based scroll reveal animations
 */

// Store observer instance for cleanup
let scrollObserver = null;

/**
 * Initialize scroll-based reveal animations
 */
export function initializeScrollAnimations() {
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    scrollObserver = new IntersectionObserver(handleIntersection, observerOptions);

    // Observe elements that should animate on scroll
    const animatedElements = document.querySelectorAll(
        '.scroll-reveal, .menu-category, .gallery-item, .review-display, .stagger-children'
    );

    animatedElements.forEach(el => {
        el.classList.add('scroll-reveal');
        scrollObserver.observe(el);
    });
}

/**
 * Handle intersection observer entries
 * @param {IntersectionObserverEntry[]} entries - Observed elements
 */
function handleIntersection(entries) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            revealElement(entry.target);
        }
    });
}

/**
 * Reveal an element with appropriate animations
 * @param {HTMLElement} element - Element to reveal
 */
function revealElement(element) {
    element.classList.add('revealed');

    // Special handling for stagger animations
    if (element.classList.contains('stagger-children')) {
        element.classList.add('animate');
    }
}

/**
 * Cleanup scroll observer (for SPA navigation)
 */
export function cleanupScrollAnimations() {
    if (scrollObserver) {
        scrollObserver.disconnect();
        scrollObserver = null;
    }
}

/**
 * Manually trigger reveal for dynamically added elements
 * @param {HTMLElement} element - Element to observe
 */
export function observeElement(element) {
    if (scrollObserver && element) {
        element.classList.add('scroll-reveal');
        scrollObserver.observe(element);
    }
}
